export default __webpack_public_path__ + "static/media/nature.4fb07107.png";